<template>
    <div>
        <div v-if="showGroupList == true">
            <div class="contact-header">
                <h1 class="heading-text">Groups <span @click="addGroups = true"><i class="glyphicon glyphicon-plus"></i> Add new Group</span></h1>
            </div>

            <div v-if="loadinggroups == true" class="loading">
                <img src="~styles/img/load.gif" alt="">
            </div>

            <div v-if="loadinggroups == false" class="contact-table table-responsive">
                <table class="table list-table spacing-table del-table">
                    <tr
                    v-for="allgroupdetals in groupDetail"
                    :key="allgroupdetals.id">
                        <td
                        style="cursor: pointer"
                        class="contact-detail enter-group"
                        :data-name="allgroupdetals.group_name"
                        :data-id="allgroupdetals.id"
                        @click="enterGroup()">
                            <img
                            :data-name="allgroupdetals.group_name"
                            :data-id="allgroupdetals.id"
                            class="user-image"
                            src="~styles/img/groups.png"
                            alt="">
                            {{allgroupdetals.group_name}}
                        </td>
                        <td>
                            <a
                            class="del-user"
                            :data-id="allgroupdetals.id"
                            @click="delUser()">
                                <i
                                :data-id="allgroupdetals.id"
                                class="el-icon-delete"></i>
                            </a>
                        </td>
                    </tr>
                </table>
            </div>
        </div>

        

        <div v-if="showGroupDetail">
            <div v-if="loadingGroupsContacts == true" class="loading">
                <img src="~styles/img/load.gif" alt="">
            </div>

            <div v-if="loadingGroupsContacts == false" class="contact-header">
                <h1 class="heading-text">{{this.currentActiveGroup}}</h1>

                <div class="other-btn">
                    <span class="text-info" @click="backtogroup()"><i class="el-icon-arrow-left"></i> Groups</span>
                    <span class="text-info" @click="editGroupName()">Edit</span>
                </div>
            </div>

            <div v-if="loadingGroupsContacts == false" class="contact-table table-responsive">
                <table class="table list-table spacing-table">
                    <tbody class="custom-table">
                        <template>
                        <tr
                        class=""
                        v-for="getcontacts in getGroupContacts"
                        :data-id="getcontacts.id"
                        :key="getcontacts.id">

                            <td class="contact-detail">
                                <img class="user-image" src="~styles/img/user.jpg" alt="">
                                {{ getcontacts.name }}
                            </td>
                            <td>{{getcontacts.code}}</td>
                            <td>{{ getcontacts.number }}</td>
                            <td style="white-space: nowrap">{{ getcontacts.age }} {{ getcontacts.gender }}</td>
                            <!-- <td>
                                <a
                                ref="theButton"
                                :data-id="getcontacts.number"
                                @click="editContactDetailBtn()"
                                >
                                    <i
                                    :data-id="getcontacts.id"
                                    :data-name="getcontacts.name"
                                    :data-number="getcontacts.number"
                                    :data-age="getcontacts.age"
                                    :data-gender="getcontacts.gender"
                                    :data-details="getcontacts.details"
                                    class="el-icon-edit"></i>
                                </a>
                            </td> -->

                        </tr>
                        </template>

                    </tbody>
                </table>
            </div>
        </div>


        <!-- dialogue for adding group -->
        <el-dialog title="Create Group" :visible.sync="addGroups" width="50%">

            <form class="content-form">
                <div class="form-group">
                    <label for="">Group Name:</label>
                    <input
                    type="text"
                    class="form-control"
                    v-model="createGroupDetail.group_name"
                    min="0"
                    autofocus>
                    <p class="text-danger">{{ creategrouperror }}</p>
                </div>
            </form>

            <span slot="footer" class="dialog-footer" left>
                <el-button @click="addGroups = false">Cancel</el-button>
                <el-button type="primary" @click="createGroup()">Save</el-button>
            </span>

        </el-dialog>

        <!-- dialogue for Editing group -->
        <el-dialog title="Edit Group" :visible.sync="editGroupForm" width="50%">

            <form class="content-form">
                <div class="form-group">
                    <label for="">Group Name:</label>
                    <input
                    type="text"
                    class="form-control"
                    v-model="editGroupDetail.group_name"
                    min="0"
                    autofocus>
                    <p class="text-danger">{{ creategrouperror }}</p>
                </div>
            </form>

            <span slot="footer" class="dialog-footer" left>
                <el-button @click="editGroupForm = false">Cancel</el-button>
                <el-button type="primary" @click="SaveGroup()">Save</el-button>
            </span>

        </el-dialog>
    </div>
</template>


<script>
import Vue from 'vue';
import axios from 'axios';
import {deletegenericgroup, editusergroup, getusersingroup, createusergroup, getusergroups, getHeader} from './../../../config';

export default {
    data() {
        return{
            loadinggroups: true,
            loadingGroupsContacts: true,

            creategrouperror: "",
            showGroupList: true,
            showGroupDetail: false,
            addGroups: false,
            editGroupForm: false,
            currentActiveGroup: "",
            createGroupDetail: {
                group_name: "",
                group_description: ""
            },
            groupDetail: [{
                id: "",
                group_name:"",
                group_description: ""
                
            }],

            editGroupDetail: {
                id: "",
                group_name:"",
                group_description: ""
            },

            getGroupContacts: [{
                id:"",
                name:"",
                code: "",
                number: "",
                age:"",
                gender:"",
                details:""
            }]
        }
    },
    methods: {
        enterGroup() {
            this.loadingGroupsContacts = true
            this.showGroupList = false
            this.showGroupDetail = true
            var activegroupid = event.target.dataset.id;
            this.currentActiveGroup = event.target.dataset.name;

            this.editGroupDetail.id = activegroupid
            this.editGroupDetail.group_name = event.target.dataset.name

            this.$nextTick(function () {
                axios
                .post(getusersingroup+activegroupid,{gid: activegroupid}, {headers: getHeader()})
                .then(Response =>{
                    this.currentActiveGroup
                    this.getGroupContacts = Response.data.data
                    this.loadingGroupsContacts = false
                })
            })
        },

        SaveGroup() {
            axios
            .post(editusergroup, this.editGroupDetail , {headers: getHeader()})
            .then(Response => {

                if(Response.data.error != "true"){
                    this.currentActiveGroup = this.editGroupDetail.group_name
                    this.editGroupForm = false

                    this.$notify({
                    group: 'foo',
                    type: 'success',
                    title: 'Success',
                    text: 'Group name successfully changed.'
                    })
                }
                else{
                    this.$notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Error',
                    text: Response.data.data
                    })
                }
                this.editContactdetails = false;
            })
            .catch(function (error){
                this.$notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Error',
                    text: 'Something went wrong'
                })
            });
        },

        backtogroup() {
            this.loadinggroups = true
            this.showGroupDetail = false
            this.showGroupList = true
            this.refreshGroup()
            this.$nextTick(function (){
                this.loadinggroups = false
            })
        },

        refreshGroup() {
            axios
            .get(getusergroups, {headers: getHeader()})
            .then(Response =>{
                // console.log(Response)
                this.groupDetail = Response.data.data
            })
        },

        createGroup() {
            axios
            .post(createusergroup,this.createGroupDetail,{headers: getHeader()})
            .then(Response =>{
                // console.log(Response)
                if(!this.createGroupDetail.group_name){
                    // console.log("Group Name is empty")
                    this.creategrouperror = "This field cant be empty"
                }
                else(
                    this.addGroups = false,

                    this.$nextTick(function () {
                        this.refreshGroup(),
                        this.creategrouperror = "",
                        this.createGroupDetail.group_name = ""

                        this.$nextTick(function () {
                            this.$notify({
                            group: 'foo',
                            type: 'success',
                            title: 'Group Created',
                            text: 'New Group is Created.'
                            })
                        })
                    })
                )
            })
            .catch(function (error){
                this.$notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Error',
                    text: 'Something went wrong'
                })
            });
        },

        editGroupName() {
            this.editGroupForm = true
        },

        delUser() {
            const clickedid = event.target.dataset.id
            this.$confirm('This will permanently delete the file. Continue?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            })
            .then(() => {
                // alert(clickedid)
                axios
                .post(deletegenericgroup,{group_id: clickedid}, {headers: getHeader()})
                .then(Response => {
                    // console.log(Response)
                    if(Response.data.error != "true"){
                        this.refreshGroup()
                        this.$nextTick(function () {
                            this.$notify({
                            group: 'foo',
                            type: 'success',
                            title: 'Success',
                            text: 'Group Successfully Deleted.'
                            })
                        })
                    }
                    else{
                        // alert("hello")
                        this.refreshGroup()
                        this.$notify({
                        group: 'foo',
                        type: 'error',
                        title: 'Error',
                        text: Response.data.data
                        })
                    }
                })
                .catch(function (error){
                    this.$notify({
                        group: 'foo',
                        type: 'error',
                        title: 'Error',
                        text: 'Something went wrong'
                    })
                });
            })
            .catch(() => {
                // alert("canceled")       
            });
        }
    },
    mounted() {
        axios
        .get(getusergroups, {headers: getHeader()})
        .then(Response =>{
            // console.log(Response)
            this.groupDetail = Response.data.data

            this.$nextTick(function (){
                this.loadinggroups = false
            })
        })
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/parts/groups.vue